<template>
  <div class="senspro">
    <p v-for="(item, index) in planichlist" :key="index" title="下载" @click="fileclick(item)">
      {{item.fileName}}<a>下载</a>
    </p>
    <p v-if="planichlistss">没有上传案例文件</p>
  </div>
</template>
<script>
import workbrnch from './../../data/emer/burst.js'
export default {
  data() {
    return {
      // 列表
      planichlist: null,
      planId: '',
      planichlistss: false
    }
  },
  created() {
    if (!sessionStorage.planIdLists) return
    this.planId = sessionStorage.planIdLists
    this.plancase_list()
  },
  methods: {
    // 获取列表
    plancase_list() {
      (async() => {
        try {
          let info = await workbrnch.plancase_list({
            planId: this.planId
          })
          if (info.status && info.data) {
            this.planichlist = info.data
            if (info.data.length < 1) {
              this.planichlistss = true
            }else{
              this.planichlistss = false
            }
          }
        } catch (err) {
          console.log(err)
        }
      })()
    },
    // 文件下载
    fileclick(m, index) {
      if (m.id) {
        window.location.href = `/api/emer/plancase/download?id=${m.id}&isOnline=false&num=${Math.random()}`
      } else {
        this.$message.warning('该类型文件暂未上传')
      }
    },
  }
}

</script>
<style scoped lang="stylus">
.senspro {
  position: relative;
  overflow: auto;
  height: 588px;
  p {
    line-height: 35px;
    font-size: 16px;
    cursor: pointer;
    text-indent: 1em;
    a {
      font-size: 14px;
      padding-left: 10px;
      color: #20a0ff;
    }
  }
}

</style>



// WEBPACK FOOTER //
// casev.vue?8a157a9e